import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import Header from './components/common/Header'
import Footer from './components/common/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Clients from './pages/Clients'
import Candidates from './pages/Candidates'
import Jobs from './pages/Jobs'
import JobDetails from './pages/JobDetails'
import Blog from './pages/Blog'
import Contact from './pages/Contact'
import Privacy from './pages/Privacy'
import Partners from './pages/Partners'
import Weightmans from './pages/partnerships/Weightmans'
import CPT from './pages/partnerships/CPT'
import TestSupabase from './pages/TestSupabase'
import TestSupabaseDebug from './pages/TestSupabaseDebug'
import LCRCAProposal from './pages/LCRCAProposal'
import LCRCAProposalNigelUpdated from './pages/LCRCAProposalNigelUpdated'
// Organised Proposal Structure
import LCRCAProposalOrganised from './proposals/lcrca/LCRCAProposal'
import LCRCAProposalNigelOrganised from './proposals/lcrca/LCRCAProposalNigelUpdated'
import TransportUKProposal from './proposals/transport-uk/TransportUKProposal'
import ArrivaProposal from './proposals/arriva/ArrivaProposal'
import TransportUKWYProposal from './proposals/transport-uk-wy/TransportUKWYProposal'
import ScrollToTop from './components/ScrollToTop'
import LiveChatIntake from './components/LiveChatIntake'

// Blog Articles
import FutureOfHGVDriving from './pages/articles/FutureOfHGVDriving'
import SafetyTips from './pages/articles/SafetyTips'
import SalaryNegotiation from './pages/articles/SalaryNegotiation'
import DriverHoursRegulations from './pages/articles/DriverHoursRegulations'
import CareerProgression from './pages/articles/CareerProgression'
import ScotlandExpansion from './pages/articles/ScotlandExpansion'

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Standalone LCRCA Proposal - No Header/Footer */}
          <Route path="/lcrca-proposal" element={<LCRCAProposal />} />
          <Route path="/LCRCAPROPOSAL" element={<LCRCAProposalNigelUpdated />} />
          
          {/* Organised Proposal Structure - Duplicated for new client use */}
          <Route path="/proposals/lcrca/original" element={<LCRCAProposalOrganised />} />
          <Route path="/proposals/lcrca/updated" element={<LCRCAProposalNigelOrganised />} />
          
          {/* Transport UK Proposal */}
          <Route path="/transport-uk-proposal" element={<TransportUKProposal />} />

          {/* Arriva Proposal */}
          <Route path="/arriva-proposal" element={<ArrivaProposal />} />

          {/* Transport UK - West Yorkshire Proposal */}
          <Route path="/transport-uk-wy-proposal" element={<TransportUKWYProposal />} />
          
          {/* Main website with Header/Footer */}
          <Route path="/*" element={
            <div className="min-h-screen flex flex-col">
              <Header />
              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/partners" element={<Partners />} />
                  <Route path="/partners/weightmans" element={<Weightmans />} />
                  <Route path="/partners/cpt" element={<CPT />} />
                  <Route path="/clients" element={<Clients />} />
                  <Route path="/candidates" element={<Candidates />} />
                  <Route path="/jobs" element={<Jobs />} />
                  <Route path="/jobs/:slug" element={<JobDetails />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/future-of-hgv-driving" element={<FutureOfHGVDriving />} />
                  <Route path="/blog/safety-tips" element={<SafetyTips />} />
                  <Route path="/blog/salary-negotiation" element={<SalaryNegotiation />} />
                  <Route path="/blog/driver-hours-regulations" element={<DriverHoursRegulations />} />
                  <Route path="/blog/career-progression" element={<CareerProgression />} />
                  <Route path="/blog/scotland-expansion" element={<ScotlandExpansion />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/test-supabase" element={<TestSupabase />} />
                  <Route path="/test-supabase-debug" element={<TestSupabaseDebug />} />
                </Routes>
              </main>
              <Footer />
              <LiveChatIntake />
            </div>
          } />
        </Routes>
      </Router>
    </HelmetProvider>
  )
}

export default App
